import CloseIcon from '@material-ui/icons/Close';
import CheckCircle from '@mui/icons-material/CheckCircle';
import client from 'client';
import { changeCurrency, formatter } from '../../../constants';
import { useEffect, useState } from 'react';
const {
  Dialog,
  Grid,
  Box,
  Divider,
  IconButton,
} = require('@mui/material');
import { useHistory } from 'react-router-dom';
import moment from 'moment/moment';
import { useTranslation } from 'react-i18next';

const firstRecord = (payload) => {
  if (Array.isArray(payload)) {
    return payload[0] || null;
  }
  if (payload && typeof payload === 'object') {
    return payload;
  }
  return null;
};

const ModalSubscriptionsPaywalls = ({
  open,
  setSubscriptionsPaywalls,
  compacctnum,
  phase: phaseProp,
  daysRemaining: daysRemainingProp,
  paymentUrl: paymentUrlProp,
  lockMode = false,
}) => {
  const [subscriptionsBill, setSubscriptionsBill] = useState(null);
  const [subscriptionInfo, setSubscriptionInfo] = useState(null);
  const history = useHistory();
  const { t } = useTranslation('navigation');

  const paymentSubscription = () => {
    const target =
      paymentUrlProp ||
      (compacctnum ? `/subscriptions/apply-payment-view/${compacctnum}` : null);

    if (!target) {
      return;
    }

    if (target.startsWith('http')) {
      window.location.assign(target);
      return;
    }

    history.push(target);
  };

  useEffect(() => {
    if (!open || !compacctnum) {
      return;
    }

    let cancelled = false;

    const loadInvoice = async () => {
      try {
        const [subscriptionResponse, billResponse] = await Promise.allSettled([
          client.get(`/subscription/subscription-company/${compacctnum}`),
          client.get(`/subscription/get-bill-company/${compacctnum}`),
        ]);

        if (cancelled) {
          return;
        }

        if (subscriptionResponse.status === 'fulfilled') {
          setSubscriptionInfo(firstRecord(subscriptionResponse.value.data));
        }

        if (billResponse.status === 'fulfilled') {
          setSubscriptionsBill(firstRecord(billResponse.value.data));
        }
      } catch (error) {
        console.log(error);
      }
    };

    loadInvoice();

    return () => {
      cancelled = true;
    };
  }, [open, compacctnum]);

  const subscription = subscriptionInfo || {};
  const bill = subscriptionsBill || {};
  const phase = phaseProp || subscription.phase;
  const isRestricted = phase === 'restricted';
  const isLocked = lockMode || phase === 'locked' || isRestricted;
  const daysRemaining =
    daysRemainingProp != null ? daysRemainingProp : subscription.daysRemaining;
  const canShowInvoice = Boolean(bill.bill_no);

  const pastDueCopy = t(
    'SUBSCRIPTION_PAST_DUE_BODY',
    'This is a friendly reminder that your Loadz subscription payment is past due. Please pay this invoice to keep full access to your account.'
  );
  const restrictedCopy = t(
    'SUBSCRIPTION_RESTRICTED_BODY',
    'Your Loadz account has been restricted because your subscription payment is past due. Pay now to restore access.'
  );
  const lockedCopy = t(
    'SUBSCRIPTION_LOCKED_BODY',
    'The 11-day grace period has ended. This account is locked. You cannot create tickets or sign in until the outstanding subscription invoice is paid.'
  );
  const statusCopy = phase === 'locked' ? lockedCopy : isRestricted ? restrictedCopy : pastDueCopy;
  const statusTitle = phase === 'locked'
    ? t('SUBSCRIPTION_LOCKED_TITLE', 'Account locked')
    : isRestricted
      ? t('SUBSCRIPTION_RESTRICTED_TITLE', 'Account restricted')
      : t('SUBSCRIPTION_PAST_DUE_TITLE', 'Payment past due');

  const handleClose = () => {
    if (isLocked) {
      return;
    }
    setSubscriptionsPaywalls(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="md"
      disableEscapeKeyDown={isLocked}
      PaperProps={{ style: { minHeight: 'auto', maxHeight: 'auto', overflow: 'scroll' } }}
      className="p-12 new-modal bg-transparent"
    >
      <div className="p-14">
          <h3 className="text-lg font-bold">
            {statusTitle}
            {bill.compname ? ` - ${bill.compname}` : ''}
          </h3>
          {!isLocked ? (
            <IconButton
              onClick={() => setSubscriptionsPaywalls(false)}
              style={{ position: 'absolute', right: 0, top: 0, padding: '25px' }}
              size="large"
            >
              <CloseIcon className="text-red-700" />
            </IconButton>
          ) : null}

          <div className=" user-profile-detail flex justify-between flex-wrap xl:flex-nowrap lg:flex-nowrap md:flex-nowrap">
            <div className="grid custom-border w-full  border-slate-200 xl:w-2/3 lg:w-4/5 md:w-4/5 xl:order-1 lg:order-1 md:order-1 order-2 border-r-2">
              <Box sx={{ my: 1, mx: 1 }}>
                <Grid
                  container
                  spacing={2}
                >
                  {canShowInvoice ? (
                    <Grid
                      item
                      xs={12}
                      md={7}
                      lg={7}
                    >
                      <div className="box pr-0 xl:pr-5 lg:pr-5 md:pr-3">
                        <div className=" bg-white	shadow-lg rounded-2xl mt-0">
                          <div className="invoice-wrapper p-10">
                            <div className="flex justify-between py-2">
                              <p className="font-bold">Invoice No:</p>
                              <p> {bill.bill_no}</p>
                            </div>

                            <div className="flex justify-between py-2">
                              <p className="font-bold">Subscriptions:</p>
                              <p> {subscription.marketing_title}</p>
                            </div>
                            <div className="flex justify-between py-2">
                              <p className="font-bold">Period:</p>
                              <p>
                                {moment(bill.current_period_start).format('MM-DD-YYYY')} to{' '}
                                {moment(bill.current_period_end).format('MM-DD-YYYY')}
                              </p>
                            </div>

                            <div className="flex justify-between py-2">
                              <p className="font-bold">Due date:</p>
                              <p>
                                {moment(bill.subscription_cancel_at).format('MMMM D, YYYY')}
                              </p>
                            </div>

                            <div className="flex justify-between py-2">
                              <p className="font-bold">Balance</p>
                              <p>{formatter.format(bill.bill_balance)}</p>
                            </div>

                            <div className="flex justify-between py-2">
                              <p className="font-bold">Invoice Amount:</p>
                              {formatter.format(bill.bill_total)}
                            </div>

                            <div className="flex justify-between py-2">
                              <p className="font-bold">Status</p>
                              <p>{subscription.status}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Grid>
                  ) : null}

                  <Grid
                    item
                    xs={12}
                    md={canShowInvoice ? 5 : 12}
                    lg={canShowInvoice ? 5 : 12}
                  >
                    {canShowInvoice ? (
                      <>
                        <div className="w-full text-center">
                          <h1 className="text-5xl font-bold">
                            {formatter.format(changeCurrency(bill.bill_balance))}
                          </h1>
                        </div>

                        <div className="w-full text-center">
                          <h1 className="text-xl">
                            {t('AMOUNT_DUE', 'Amount Due')}
                          </h1>
                        </div>
                      </>
                    ) : null}

                    <div className="box mt-32 flex w-full justify-center">
                      <button
                        onClick={() => paymentSubscription()}
                        className="rounded-none border-solid border-1 w-4/5 border-black py-10 px-32 text-white bg-black font-medium hover:bg-white hover:text-black ease-in duration-300 mx-auto"
                      >
                        {t('PAY_NOW', 'Pay Now')}
                      </button>
                    </div>
                  </Grid>
                </Grid>
              </Box>

              <br />
              <br />
              <Divider />
              <div className="box pr-0 xl:pr-10 lg:pr-10 md:pr-10">
                <h5 className="font-bold">
                  {t(
                    'SUBSCRIPTION_PAY_NOW_BENEFITS',
                    'Pay now and continue enjoying the following benefits:'
                  )}
                </h5>
                <ul style={{ paddingLeft: '16px', paddingRight: '16px', marginTop: '5px' }}>
                  <Box sx={{ my: 1, mx: 1 }}>
                    <Grid
                      container
                      spacing={2}
                    >
                      <Grid
                        item
                        xs={12}
                        md={6}
                        lg={6}
                      >
                        <div>
                          <li>
                            <CheckCircle className="text-green-700" /> Create New Customer
                          </li>
                          <li>
                            <CheckCircle className="text-green-700" /> Create New Job
                          </li>
                          <li>
                            <CheckCircle className="text-green-700" /> Create New Driver
                          </li>
                          <li>
                            <CheckCircle className="text-green-700" /> Create New Truck
                          </li>
                        </div>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        md={6}
                        lg={6}
                      >
                        <div>
                          <li>
                            <CheckCircle className="text-green-700" /> Create New Trailer
                          </li>
                          <li>
                            <CheckCircle className="text-green-700" /> Create New Owner Operator
                          </li>
                          <li>
                            <CheckCircle className="text-green-700" /> Create New Subcontractor
                          </li>
                          <li>
                            <CheckCircle className="text-green-700" /> Create tickets and sign in
                          </li>
                        </div>
                      </Grid>
                    </Grid>
                  </Box>
                </ul>
              </div>
            </div>

            <div className="main-column w-full xl:w-1/3 lg:w-2/4 md:w-2/5 xl:order-2 lg:order-2 md:order-1 order-1 flex h-full">
              <div className="box pl-0 xl:pl-20 lg:pl-20 mb-20  w-full h-full flex justify-center  items-center flex-col text-center ">
                <div className="bg-white shadow overflow-hidden sm:rounded-lg">
                  <div className="px-4 py-5 sm:px-6 flex justify-between items-center">
                    <div>
                      <h3 className="text-lg leading-6 font-medium text-gray-900">
                        {statusTitle}
                      </h3>
                      <br />
                      <p className="mt-1 max-w-2xl text-sm text-gray-500">
                        {statusCopy}
                      </p>
                      {!isLocked && daysRemaining != null ? (
                        <p className="mt-12 max-w-2xl text-sm font-medium text-gray-700">
                          {t('SUBSCRIPTION_DAYS_REMAINING', {
                            count: daysRemaining,
                            defaultValue: '{{count}} day(s) left in the 11-day grace period.',
                          })}
                        </p>
                      ) : null}
                    </div>
                  </div>
                  <div className="box mt-32 flex w-full justify-center">
                    <button
                      type="button"
                      onClick={() => paymentSubscription()}
                      className="rounded-none border-solid border-1 w-4/5 border-black py-10 px-32 text-white bg-black font-medium hover:bg-white hover:text-black ease-in duration-300 mx-auto"
                    >
                      {t('PAY_NOW', 'Pay Now')}
                    </button>
                  </div>
                  <div className="w-full text-center p-20">
                    <p className="mt-1 max-w-2xl text-sm text-gray-500">
                      {t(
                        'SUBSCRIPTION_NEED_HELP',
                        'Need help? Contact Support at support@loadz.com.'
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </Dialog>
  );
};

export default ModalSubscriptionsPaywalls;
